<template>
  <div id="contenedor">
    <v-layout row wrap>
      <v-flex xs11 class="offset-half">
        <v-card class="table" elevation="4">
          <v-toolbar flat elevation="4">
            <v-card class="icon">
              <v-icon
                style="margin-left: 30px; margin-top: 25px"
                color="white"
                x-large=""
                >mdi-folder-information-outline</v-icon
              >
            </v-card>
            <div class="usuario">SUSPENDIDOS</div>
            <!-- Botón de actualizar manual -->
            <v-btn
              color="#1D3C7F"
              @click="obtenerCasos"
              class="ml-5 update-btn"
              style="color: white; font-weight: bold"
              :loading="loadingObtenerCasos"
              :disabled="loadingObtenerCasos"
            >
              <template v-if="!loadingObtenerCasos">
                <v-icon size="28px">mdi-refresh</v-icon>
              </template>
              <template v-else>
                <v-progress-circular
                  indeterminate
                  color="white"
                  size="24"
                ></v-progress-circular>
              </template>
            </v-btn>
            <v-spacer></v-spacer>

            <!-- Filtro para cambiar vista -->
            <div class="filter-container">
              <!-- Select normal para pantallas grandes -->
              <v-select
                v-if="!$vuetify.breakpoint.xs"
                v-model="selectedFilter"
                :items="filterOptions"
                item-text="text"
                item-value="value"
                label="Cambiar vista"
                outlined
                dense
                style="max-width: 150px; font-size: 13.5px"
                @change="changeFilter"
              ></v-select>

              <!-- Solo icono para pantallas pequeñas -->
              <v-menu
                v-if="$vuetify.breakpoint.xs"
                v-model="showFilterMenu"
                :close-on-content-click="false"
                offset-y
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-btn icon v-bind="attrs" v-on="on" class="filter-icon-btn">
                    <v-icon>mdi-filter-variant</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item
                    v-for="option in filterOptions"
                    :key="option.value"
                    @click="selectFilterOption(option.value)"
                  >
                    <v-list-item-title>{{ option.text }}</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-toolbar>
          <br />
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            label="Buscar caso suspendido"
            class="text-field"
            single-line
            color="#111c3d"
          ></v-text-field>
          <br />
          <v-data-table
            :headers="headers"
            :items="casos"
            :search="search"
            v-model="casosSeleccionados"
            show-select
            item-key="cc_id_caso"
            style="border: 2px solid #111c3d"
            class="elevation-3"
            must-sort
          >
            <template v-slot:footer.prepend>
              <v-btn
                color="#1D3C7F"
                class="reactivar-casos-btn"
                :disabled="casosSeleccionados.length < 2"
                @click="abrirConfirmacionAsignacionMasiva"
                style="color: whitesmoke; font-weight: bold"
                large
              >
                <v-icon left style="color: whitesmoke"
                  >mdi-account-multiple-plus</v-icon
                >
                REACTIVAR CASOS MASIVOS
              </v-btn>
            </template>
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <template v-slot:[`item.cc_prioridad_requerimiento`]="{ item }">
              <div v-if="item.cc_prioridad_requerimiento === '3'">
                <v-chip outlined class="ma-2" :color="item.color">
                  ALTA
                </v-chip>
              </div>
              <div v-if="item.cc_prioridad_requerimiento === '2'">
                <v-chip outlined class="ma-2" :color="item.color">
                  MEDIA
                </v-chip>
              </div>
              <div v-if="item.cc_prioridad_requerimiento === '1'">
                <v-chip outlined class="ma-2" :color="item.color">
                  BAJA
                </v-chip>
              </div>
            </template>
            <template v-slot:[`item.cc_id_asesor`]="{ item }">
              <v-icon color="primary" @click="handleAsesor(item.infoAsesor)">
                mdi-account-tie
              </v-icon>
              <v-icon color="purple" @click="verHistorial(item)" class="ml-1">
                mdi-timeline-clock
              </v-icon>
            </template>
            <!-- tabla donde se pintan los datos obtenidos del arreglo -->
            <template v-slot:[`item.semaforo`]="{ item }">
              <SemaforoTiempo
                :fecha-inicio="item.fecha_area"
                :dias="requerimientosInfo[item.cc_id_requerimiento]?.dias || 0"
                :horas="
                  requerimientosInfo[item.cc_id_requerimiento]?.horas || 0
                "
                :minutos="
                  requerimientosInfo[item.cc_id_requerimiento]?.minutos || 0
                "
                :id-caso="item.cc_id_caso"
                :tiempo-restante-backend="item.tiempoRestanteBackend"
                :estado-caso="item.cerrados"
                :dias-festivos="diasFestivos"
                @caso-vencido="handleCasoVencido"
              />
            </template>
            <template v-slot:[`item.action`]="{ item }">
              <!-- BOTÓN VERDE: REACTIVAR DIRECTAMENTE CON CONFIRMACIÓN SIMPLE -->
              <v-icon
                color="green"
                class="mr-2"
                @click="confirmarReactivarCaso(item)"
                title="Reactivar caso"
              >
                mdi-cog-clockwise
              </v-icon>
              <v-icon color="blue" class="mr-2" @click="verConversacion(item)">
                mdi-eye
              </v-icon>
              <v-icon
                v-if="
                  (item.escalamiento == null && item.id_especialista == 0) ||
                  item.cerrados == 3
                "
                color="red"
                class="mr-2"
                @click="escalar(item)"
              >
                mdi-elevator-up
              </v-icon>
              <v-icon
                color="#1D3C7F"
                class="mr-2"
                @click="verObservacion(item)"
              >
                mdi-clipboard-text
              </v-icon>
              <v-icon
                color="orange"
                class="mr-2"
                @click="abrirAgregarObservacion(item)"
              >
                mdi-comment-plus
              </v-icon>
            </template>
            <template v-slot:no-data>
              <v-alert :value="true" color="#111c3d" icon="mdi-alert" outlined
                >No se encontro su busqueda</v-alert
              >
            </template>
          </v-data-table>
          <v-dialog
            v-model="dialogConfirmarAsignacionMasiva"
            max-width="500px"
            persistent
          >
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-clipboard-check-outline</v-icon>
                  Reactivar casos
                </span>
              </v-card-title>
              <v-card-text>
                <v-container grid-list-md>
                  <v-card-text style="font-size: 18px; color: black">
                    ¿Está seguro que desea reactivar estos casos?
                  </v-card-text>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn
                  color="#1D3C7F"
                  dark
                  @click="dialogConfirmarAsignacionMasiva = false"
                  >NO</v-btn
                >
                <v-btn color="#1D3C7F" dark @click="confirmarAsignacionMasiva"
                  >SI</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Modal para escalar caso -->
          <v-dialog v-model="dialog5" max-width="800px" persistent>
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white"
                  ><v-icon color="white">mdi-elevator-up</v-icon> Escalar</span
                >
              </v-card-title>
              <!-- componente del modal para agregar y actualizar -->
              <v-card-text>
                <v-layout wrap>
                  <v-flex xs12 sm6 md5 class="mr-14 mt-5">
                    <v-autocomplete
                      color="#294697"
                      persistent-hint
                      v-model="editedItem.idArea"
                      label="Area"
                      :items="areas"
                      item-value="idArea"
                      item-text="area"
                      @change="llamarRequerimientos(editedItem.idArea)"
                    ></v-autocomplete>
                  </v-flex>
                  <v-flex xs12 sm6 md6 class="mt-5">
                    <v-autocomplete
                      color="#294697"
                      persistent-hint
                      v-model="editedItem.requerimientos"
                      label="Requerimiento"
                      :items="requerimientos"
                      item-value="cc_id_requerimientos"
                      :item-text="
                        (item) =>
                          item.cc_nombre_requerimiento_con_empresa ||
                          item.cc_nombre_requerimiento
                      "
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title>{{
                            item.cc_nombre_requerimiento
                          }}</v-list-item-title>
                          <v-list-item-subtitle v-if="item.nombreEmpresa">
                            <strong>{{ item.nombreEmpresa }}</strong>
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                      <template v-slot:selection="{ item }">
                        <span
                          >{{ item.cc_nombre_requerimiento }}
                          <strong v-if="item.nombreEmpresa"
                            >({{ item.nombreEmpresa }})</strong
                          ></span
                        >
                      </template>
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <!-- botones para cancelar y agregregar y validacion de campos vacios -->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" dark @click="close5">CERRAR</v-btn>
                <v-btn
                  color="#1D3C7F"
                  style="color: white"
                  @click="save5(idCaso)"
                  :disabled="!editedItem.idArea || !editedItem.requerimientos"
                  >ESCALAR</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- alertas de las acciones que se hacen -->
          <v-snackbar
            v-model="snackbar"
            :bottom="y === 'bottom'"
            :left="x === 'left'"
            :multi-line="mode === 'multi-line'"
            :right="x === 'right'"
            :timeout="timeout"
            :top="y === 'top'"
            :vertical="mode === 'vertical'"
            color="#294697"
            style="color: white"
          >
            <span v-html="text"></span>
            <v-btn color="#294697" depressed @click="snackbar = false"
              >Cerrar</v-btn
            >
          </v-snackbar>
          <CaseHistoryTimeline
            v-if="idCasoActual !== null"
            :caseId="idCasoActual"
            :visible.sync="dialogHistorial"
          />
          <!-- Modal para ver las evidencias del caso -->
          <v-dialog v-model="dialogEvidencias" max-width="900px">
            <v-card>
              <v-card-title class="nav">
                <span class="headline" style="color: white">
                  <v-icon color="white">mdi-image-multiple</v-icon>
                  Evidencias del caso #{{ idCasoActual }}
                </span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <div v-if="cargandoEvidencias" class="text-center my-5">
                    <v-progress-circular
                      indeterminate
                      color="#294697"
                    ></v-progress-circular>
                    <p>Cargando evidencias...</p>
                  </div>
                  <div v-else-if="!evidencias.length" class="text-center my-5">
                    <v-alert type="info" outlined>
                      No hay evidencias disponibles para este caso.
                    </v-alert>
                  </div>
                  <v-row v-else>
                    <v-col
                      v-for="(evidencia, index) in evidencias"
                      :key="index"
                      cols="12"
                      sm="6"
                      md="4"
                    >
                      <v-card outlined>
                        <template
                          v-if="isImageUrl(evidencia.cc_ruta_evidencia)"
                        >
                          <v-img
                            :src="evidencia.cc_ruta_evidencia"
                            aspect-ratio="1"
                            class="grey lighten-2"
                            @click="
                              verImagenCompleta(evidencia.cc_ruta_evidencia)
                            "
                            style="cursor: pointer"
                          >
                            <template v-slot:placeholder>
                              <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                              >
                                <v-progress-circular
                                  indeterminate
                                  color="#294697"
                                ></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                        </template>
                        <template v-else>
                          <v-card
                            class="d-flex flex-column align-center justify-center pa-3"
                            style="
                              cursor: pointer;
                              aspect-ratio: 1;
                              height: 100%;
                            "
                            @click="downloadFile(evidencia.cc_ruta_evidencia)"
                          >
                            <v-icon size="80" color="grey darken-1"
                              >mdi-file-document-outline</v-icon
                            >
                            <div
                              class="mt-2 text-caption grey--text text--darken-1 text-center"
                              style="word-break: break-all"
                            >
                              {{ getFileName(evidencia.cc_ruta_evidencia) }}
                            </div>
                          </v-card>
                        </template>
                        <v-card-text class="pa-2">
                          <small class="grey--text">{{
                            formatDate(evidencia.fecha_subida)
                          }}</small>
                        </v-card-text>
                      </v-card>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="#1D3C7F" dark @click="closeEvidencias"
                  >CERRAR</v-btn
                >
              </v-card-actions>
            </v-card>
          </v-dialog>

          <!-- Modal para ver una imagen en pantalla completa -->
          <v-dialog v-model="dialogImagenCompleta" max-width="90vw" fullscreen>
            <v-card flat>
              <v-toolbar dark color="#1D3C7F" flat>
                <v-btn icon dark @click="descargarImagen">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                <v-toolbar-title>Evidencia</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon dark @click="dialogImagenCompleta = false">
                  <v-icon>mdi-close</v-icon>
                </v-btn>
              </v-toolbar>
              <v-card-text
                class="pa-0 d-flex justify-center align-center"
                style="height: calc(100vh - 64px); background-color: #000"
              >
                <img
                  :src="imagenSeleccionada"
                  style="max-height: 95vh; max-width: 95vw; object-fit: contain"
                />
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-card>
      </v-flex>
    </v-layout>
    <v-dialog v-model="dialogAgregarObservacion" max-width="500px">
      <v-card>
        <v-card-title>Agregar Observación</v-card-title>
        <v-card-text>
          <v-textarea
            class="pt-5"
            v-model="nuevaObservacion"
            label="Observación"
            rows="2"
          />
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text @click="dialogAgregarObservacion = false">Cancelar</v-btn>
          <v-btn color="primary" @click="guardarObservacion">Guardar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <CaseHistoryTimeline
      v-if="idCasoActual !== null"
      :caseId="idCasoActual"
      :visible.sync="dialogHistorialObservaciones"
      :soloObservaciones="true"
    />

    <!-- MODAL DEL ASESOR ------------------------------------ -->
    <v-dialog
      class="dialogAsesor"
      v-model="showDialogAsesor"
      persistent
      max-width="400"
    >
      <v-card class="mx-auto" max-width="400" outlined>
        <v-list-item three-line>
          <v-list-item-content>
            <div class="text-overline mb-4">INFO. ASESOR</div>
            <v-list-item-title class="text-h6 mb-2">
              {{ objAsesor.nombre }}
            </v-list-item-title>
            <v-list-item-subtitle class="mb-2 mt-2">
              <v-icon class="mr-2" size="19">mdi-card-account-details</v-icon>
              {{ objAsesor.cedula }}
            </v-list-item-subtitle>
            <v-list-item-subtitle>
              <v-icon class="mr-2" size="20">mdi-phone</v-icon>
              {{ objAsesor.telefono }}
            </v-list-item-subtitle>
          </v-list-item-content>
          <v-list-item-avatar size="80" color="blue" rounded="50">
            <v-icon size="60" color="white"> mdi-account-tie </v-icon>
          </v-list-item-avatar>
        </v-list-item>
        <v-card-actions>
          <v-btn
            color="primary"
            elevation="2"
            outlined
            raised
            class="ms-auto"
            @click="showDialogAsesor = false"
            >Cerrar</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- /MODAL DEL ASESOR ------------------------------------ -->

    <!-- Dialog que permite visualizar la conversacion -->
    <v-dialog v-model="dialog2" max-width="500px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white">mdi-message-bulleted</v-icon
            >Conversación</span
          >
        </v-card-title>
        <!-- componente del modal para agregar y actualizar -->
        <v-card-text>
          <div v-for="(chat, index) in chatItem" :key="index">
            <v-card class="mt-3 mx-auto" width="550">
              <v-card-subtitle v-if="chat.user == 'NOVA'" class="pb-0">
                <p class="indigo--text text--darken-3">
                  <v-icon color="indigo darken-4" class="ml-5 mr-1"
                    >mdi-robot</v-icon
                  >{{ chat.user }}
                </p>
              </v-card-subtitle>
              <v-card-subtitle v-else class="d-flex justify-end">
                <p class="deep-purple--text text--accent-3">
                  <v-icon color="deep-purple accent-4" class="ml-5 mr-1"
                    >mdi-face</v-icon
                  >{{ chat.user }}
                </p>
              </v-card-subtitle>
              <v-card-text v-if="chat.user == 'NOVA'" class="">
                <p class="grey--text text--darken-1 text-left chat-message">
                  {{ chat.message }}
                </p>
              </v-card-text>
              <v-card-text v-else class="d-flex justify-end">
                <p class="grey--text text--darken-1 text-right chat-message">
                  {{ chat.message }}
                </p>
              </v-card-text>
            </v-card>
          </div>
          <v-divider class="mt-5"></v-divider>
        </v-card-text>
        <!-- botones para cancelar y agregar y validacion de campos vacios -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="#1D3C7F"
            dark
            @click="verEvidencias(idCasoActual)"
            class="mr-2"
          >
            <v-icon left>mdi-image-multiple</v-icon>
            VER EVIDENCIAS
          </v-btn>
          <v-btn color="#1D3C7F" dark @click="close2">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog que permite ver las observaciones -->
    <v-dialog v-model="dialog3" max-width="500px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white"
            ><v-icon color="white">mdi-message-bulleted</v-icon> Observacion del
            caso</span
          >
        </v-card-title>
        <!-- componente del modal para agregar y actualizar -->
        <v-card-text class="pa-5">
          <p style="font-size: 18px">
            {{
              observacion
                ? observacion
                : "No se ingreso una observación para este caso"
            }}
          </p>
        </v-card-text>
        <!-- botones para cancelar y agregregar y validacion de campos vacios -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="close3">CERRAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- DIALOG SIMPLE DE CONFIRMACIÓN PARA REACTIVAR -->
    <v-dialog v-model="dialogConfirmarReactivar" max-width="500px" persistent>
      <v-card>
        <v-card-title class="nav">
          <span class="headline" style="color: white">
            <v-icon color="white">mdi-check-circle</v-icon>
            Confirmar Reactivación
          </span>
        </v-card-title>
        <v-card-text>
          <v-container grid-list-md>
            <v-card-text style="font-size: 18px; color: black">
              ¿Está seguro que desea reactivar el caso #{{ idCaso }}?
            </v-card-text>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#1D3C7F" dark @click="dialogConfirmarReactivar = false"
            >NO</v-btn
          >
          <v-btn color="#1D3C7F" dark @click="reactivarCasoDirecto">SI</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import swal from "sweetalert";
import axios from "axios";
import env from "../../env";
import CaseHistoryTimeline from "./CaseHistoryTimeline.vue";
import SemaforoTiempo from "./SemaforoTiempo.vue";

export default {
  components: {
    CaseHistoryTimeline,
    SemaforoTiempo,
  },
  data() {
    return {
      // Propiedades para el filtro
      selectedFilter: "suspendidos",
      showFilterMenu: false,
      filterOptions: [
        { text: "TICKETS", value: "tickets" },
        { text: "PENDIENTES", value: "pendientes" },
        { text: "ASIGNADOS", value: "asignados" },
        { text: "SUSPENDIDOS", value: "suspendidos" },
        { text: "CERRADOS", value: "cerrados" },
      ],

      /////////////////////////////////////////////JEMPODER
      previewImage: null,
      filesToUpload: null,
      /////////////////////////////////////////////JEMPODER
      objAsesor: {
        nombre: "",
        cedula: "",
        telefono: "",
        correo: "",
      },
      showDialogAsesor: false,
      show: false,
      nombre: localStorage.getItem("nombre"),
      idCargo: localStorage.getItem("idCargo"),
      snackbar: false,
      y: "top",
      x: null,
      mode: "",
      timeout: 6000,
      text: "",
      search: "",
      casos: [],
      items: [],
      value: null,
      idCaso: null,
      idEmpresaCaso: null,
      dialog2: false,
      dialog3: false,
      dialog5: false,
      dialogConfirmarReactivar: false, // DIALOG SIMPLE PARA CONFIRMAR
      fechaArea: "",
      casoPendienteObj: {},
      dialogHistorial: false,
      idCasoActual: null,
      observacion: "",
      headers: [
        {
          text: "ACCIONES",
          value: "action",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "ID",
          value: "cc_id_caso",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "AREA",
          value: "cc_nombre_area",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "PUNTO",
          value: "nombre_punto",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "EMPRESA",
          value: "nombreEmpresa",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "MUNICIPIO",
          value: "municipio",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "PRIORIDAD",
          value: "cc_prioridad_requerimiento",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "FECHA/HORA APERTURA",
          value: "fecha_inicio",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "REQUERIMIENTO",
          value: "cc_nombre_requerimiento",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "ESPECIALISTA",
          value: "nombre_especialista",
          align: "center",
          class: "column",
          sortable: false,
        },
        {
          text: "INFO. ASESOR",
          value: "cc_id_asesor",
          align: "center",
          class: "column",
          sortable: false,
        },
      ],
      requerimientos: [],
      defaultItem: [],
      editedIndex: -1,
      editedItem: {
        Observaciones: "",
        requerimientos: "",
        idArea: "",
        area: "",
        estado: null,
        observacion: "",
      },
      areas: [],
      defaultItem3: [],
      editedItem3: {
        Observaciones: "",
      },
      chatItem: [],
      requerimientosInfo: {},
      dialogEvidencias: false,
      dialogImagenCompleta: false,
      evidencias: [],
      cargandoEvidencias: false,
      imagenSeleccionada: "",
      diasFestivos: [],
      casosSeleccionados: [],
      dialogConfirmarAsignacionMasiva: false,
      motivoReactivacion: "",
      fechaReactivacion: "",
      dialogAgregarObservacion: false,
      nuevaObservacion: "",
      casoSeleccionado: null,
      dialogHistorialObservaciones: false,
      loadingObtenerCasos: false,
    };
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  async mounted() {
    await this.cargarDiasFestivos();
    await this.cargarEspecialistas(); // <-- Agrega esto
    await this.obtenerAreas();
    this.obtenerTodo();
    this.obtenerCasos();
    setInterval(() => {
      this.obtenerCasos();
    }, 60000);
  },

  methods: {
    // Método para cambiar de vista
    changeFilter() {
      this.$emit("change-view", this.selectedFilter);
    },

    selectFilterOption(value) {
      this.selectedFilter = value;
      this.showFilterMenu = false;
      this.$emit("change-view", value);
    },

    isImageUrl(url) {
      if (!url) return false;
      return /\.(jpeg|jpg|gif|png|webp|svg)$/i.test(url);
    },

    //Inicio metodos para ingresar imagenes jempoder//////////////ed
    handleDrop(event) {
      event.preventDefault();
      if (event.dataTransfer.files.length > 0) {
        this.showPreview(event.dataTransfer.files[0]);
        this.filesToUpload = event.dataTransfer.files;
      }
    },

    handlePaste(event) {
      event.preventDefault();
      const items = (event.clipboardData || event.originalEvent.clipboardData)
        .items;
      for (const item of items) {
        if (item.kind === "file") {
          const file = item.getAsFile();
          this.showPreview(file);
          this.filesToUpload = [file];
        }
      }
    },

    handleFileChange() {
      const files = this.$refs.fileInput.files;
      if (files.length > 0) {
        this.showPreview(files[0]);
        this.filesToUpload = files;
      }
    },

    openFileInput() {
      this.$refs.fileInput.click();
    },

    showPreview(file) {
      const reader = new FileReader();
      reader.onload = (event) => {
        this.previewImage = event.target.result;
      };
      reader.readAsDataURL(file);
    },

    uploadFiles(idCaso, uploadFiles) {
      if (this.filesToUpload) {
        const formData = new FormData();
        formData.append("file", this.filesToUpload[0]);
        formData.append("cc_id_caso", this.idCaso);

        axios
          .post(`${env.endpointEvidencias}`, formData)
          .then((response) => {
            this.filesToUpload = null;
            this.previewImage = null;
          })
          .catch((error) => {
            console.error(error);
          });
      }
    },
    //Fin Metodos para ingresar imagenes/////////////////////ed

    handleAsesor(asesor) {
      this.objAsesor = {
        nombre: asesor.nombre,
        telefono: asesor.celular,
        correo: asesor.correo,
        cedula: asesor.cedula,
      };
      this.showDialogAsesor = true;
    },

    obtenerTodo() {
      const idUsuario = localStorage.getItem("id");
      axios
        .get(
          `${env.endpoint}callcenter/requerimientostodos?idUsuario=${idUsuario}`,
        )
        .then((res) => (this.todosRequerimientos = res.data));
    },

    // Método SIMPLE para confirmar reactivación
    confirmarReactivarCaso(item) {
      this.idCaso = item.cc_id_caso;
      this.dialogConfirmarReactivar = true;
    },

    // Método SIMPLE para reactivar directamente
    async reactivarCasoDirecto() {
      try {
        // Obtener el caso
        const caso = this.casos.find((c) => c.cc_id_caso == this.idCaso);
        if (!caso) {
          this.text = "Caso no encontrado";
          this.snackbar = true;
          return;
        }

        // Determinar el nuevo estado (2 si tenía especialista, 0 si no)
        const nuevoEstado = caso.id_especialista > 0 ? 2 : 0;
        const observacion = "Caso reactivado desde suspendidos";

        const url = `${env.endpoint}callcenter/cambiarEstado?idCaso=${
          this.idCaso
        }&cerrados=${nuevoEstado}&observacion=${encodeURIComponent(
          observacion,
        )}&reiniciarContador=1`;

        const res = await axios.get(url);
        if (res.data.estado) {
          // Registrar en historial
          await axios.post(`${env.endpoint}historial/registrar_accion`, {
            cc_id_caso: this.idCaso,
            accion: 7,
            idUsuario: localStorage.getItem("id"),
            observaciones: observacion,
          });

          // Remover de la lista local
          const casoIndex = this.casos.findIndex(
            (c) => c.cc_id_caso == this.idCaso,
          );
          if (casoIndex >= 0) {
            this.casos.splice(casoIndex, 1);
          }

          this.text = "Caso reactivado correctamente";
          this.snackbar = true;
        } else {
          this.text = "No se pudo reactivar el caso";
          this.snackbar = true;
        }
      } catch (error) {
        console.error("Error reactivando caso:", error);
        this.text = "Error al reactivar el caso";
        this.snackbar = true;
      }

      this.dialogConfirmarReactivar = false;
    },

    // Metodo para obtener todos lo incidentes suspendidos
    async obtenerCasos() {
      if (this.loadingObtenerCasos) {
        return;
      }

      this.loadingObtenerCasos = true;

      try {
        const idUsuario = localStorage.getItem("id");

        // Primero, cargar información de requerimientos
        try {
          const resReq = await axios.get(
            `${env.endpoint}callcenter/requerimientostodos?idUsuario=${idUsuario}`,
          );
          this.requerimientosInfo = {};
          if (resReq.data && Array.isArray(resReq.data)) {
            resReq.data.forEach((req) => {
              if (req && req.cc_id_requerimiento) {
                this.requerimientosInfo[req.cc_id_requerimiento] = req;
              }
            });
          }
        } catch (error) {
          console.warn("No se pudieron cargar los requerimientos:", error);
          this.requerimientosInfo = {};
        }

        // Determinar el endpoint según el cargo
        let endpointCasos;
        const idCargo = localStorage.getItem("idCargo");

        if (idCargo == "3" || idCargo == "4") {
          endpointCasos = `${
            env.endpoint
          }callcenter/incidentesSuspendidosAreasEspeciales?idUsuario=${localStorage.getItem(
            "id",
          )}`;
        } else {
          endpointCasos = `${
            env.endpoint
          }callcenter/incidentesSuspendidos?idUsuario=${localStorage.getItem(
            "id",
          )}&idCargo=${localStorage.getItem("idCargo")}`;
        }

        console.log("Obteniendo casos suspendidos desde:", endpointCasos);

        // Obtener los casos
        const response = await axios.get(endpointCasos);

        // Verificar si la respuesta es válida
        if (!response.data) {
          console.log("Respuesta vacía del backend");
          this.casos = [];
          this.text = "No hay casos suspendidos";
          this.snackbar = true;
          this.loadingObtenerCasos = false;
          return;
        }

        // Verificar si es un array (el backend devuelve array directo, no objeto con estado)
        if (!Array.isArray(response.data)) {
          console.error(
            "Respuesta inválida del backend, esperaba array:",
            response.data,
          );
          this.casos = [];
          this.text = "Error en formato de respuesta";
          this.snackbar = true;
          this.loadingObtenerCasos = false;
          return;
        }

        console.log(`Se obtuvieron ${response.data.length} casos suspendidos`);

        // Si no hay casos, mostrar mensaje y salir
        if (response.data.length === 0) {
          this.casos = [];
          this.text = "No hay casos suspendidos";
          this.snackbar = true;
          this.loadingObtenerCasos = false;
          return;
        }

        // Cargar especialistas primero
        await this.cargarEspecialistas();

        // Procesar cada caso
        for (let i = 0; i < response.data.length; i++) {
          const caso = response.data[i];

          // Asignar color por prioridad
          if (caso.cc_prioridad_requerimiento === "1") {
            caso.color = "green";
          } else if (caso.cc_prioridad_requerimiento === "2") {
            caso.color = "orange";
          } else {
            caso.color = "red";
          }

          // Estado del caso (suspendido = 3)
          caso.cerrados = 3;
          caso.estado_caso = 3;

          // Asignar nombre del especialista
          if (caso.id_especialista && caso.id_especialista > 0) {
            // Buscar en la lista de especialistas cargados
            const especialista = this.especialistasDisponibles.find(
              (e) => e.idUsuario == caso.id_especialista,
            );

            if (especialista && especialista.nombre) {
              caso.nombre_especialista = especialista.nombre;
            } else {
              // Si no encontramos, intentar obtener el nombre
              caso.nombre_especialista = await this.obtenerNombreEspecialista(
                caso.id_especialista,
              );
            }
          } else {
            caso.nombre_especialista = "No asignado";
          }

          // Asegurar que las propiedades necesarias existan
          if (!caso.nombre_punto) caso.nombre_punto = "Sin punto";
          if (!caso.nombreEmpresa) caso.nombreEmpresa = "Sin empresa";
          if (!caso.municipio) caso.municipio = "Sin dirección";
        }

        // Obtener tiempos restantes (solo si hay casos)
        if (response.data.length > 0) {
          const ids = response.data.map((caso) => caso.cc_id_caso);
          try {
            const tiempoResponse = await axios.post(
              `${env.endpoint}callcenter/tiemposRestantes`,
              { ids },
            );
            if (
              tiempoResponse.data &&
              tiempoResponse.data.estado &&
              tiempoResponse.data.resultados
            ) {
              const tiempos = tiempoResponse.data.resultados;

              // Asignar tiempos a cada caso
              for (let i = 0; i < response.data.length; i++) {
                const tiempo = tiempos.find(
                  (t) => t.idCaso === response.data[i].cc_id_caso,
                );
                if (tiempo) {
                  response.data[i].tiempoRestanteBackend =
                    tiempo.tiempo_restante;
                  response.data[i].estado_caso =
                    Number(tiempo.estado_caso) || 3;
                }
              }
            }
          } catch (error) {
            console.warn(
              "No se pudieron obtener los tiempos restantes:",
              error,
            );
          }
        }

        // Asignar los casos procesados ordenados por fecha_inicio ASC
        response.data.sort((a, b) => {
          const fA = a.fecha_inicio || "";
          const fB = b.fecha_inicio || "";
          return fA.localeCompare(fB);
        });
        this.casos = response.data;

        // Mostrar mensaje de éxito
        if (response.data.length > 0) {
          this.text = `Se encontraron ${response.data.length} casos suspendidos`;
          this.snackbar = true;
        }
      } catch (error) {
        console.error("Error al obtener casos suspendidos:", error);
        this.casos = [];

        // Mostrar error específico
        if (error.response) {
          this.text = `Error ${error.response.status}: ${
            error.response.data || "Error del servidor"
          }`;
        } else if (error.request) {
          this.text = "No se pudo conectar con el servidor";
        } else {
          this.text = "Error al procesar la solicitud";
        }

        this.snackbar = true;
      } finally {
        // SIEMPRE asegurarse de detener el loading
        this.loadingObtenerCasos = false;
      }
    },

    async cargarEspecialistas() {
      try {
        const idCargo = localStorage.getItem("idCargo");
        const idUsuario = localStorage.getItem("id");

        const res = await axios.get(
          `${env.endpoint}callcenter/get_especialistas?idCargo=${idCargo}&idUsuario=${idUsuario}`,
        );

        if (res.data && Array.isArray(res.data)) {
          this.especialistasDisponibles = res.data;
          localStorage.setItem("especialistas_cache", JSON.stringify(res.data));
        } else {
          this.especialistasDisponibles = [];
        }
      } catch (error) {
        console.error("Error al cargar especialistas:", error);
        this.especialistasDisponibles = [];
      }
    },

    async obtenerNombreEspecialista(idEspecialista) {
      try {
        // Si ya tenemos especialistas cargados, buscar ahí
        if (this.especialistasDisponibles.length > 0) {
          const especialista = this.especialistasDisponibles.find(
            (e) => e.idUsuario == idEspecialista,
          );
          if (especialista && especialista.nombre) {
            return especialista.nombre;
          }
        }

        // Intentar desde localStorage
        const especialistasCache = localStorage.getItem("especialistas_cache");
        if (especialistasCache) {
          const especialistas = JSON.parse(especialistasCache);
          const especialista = especialistas.find(
            (e) => e.idUsuario == idEspecialista,
          );
          if (especialista && especialista.nombre) {
            return especialista.nombre;
          }
        }

        // Intentar con endpoint individual
        const response = await axios.get(
          `${env.endpoint}usuarios/get_usuario_por_id?id=${idEspecialista}`,
        );

        if (response.data && response.data.nombre) {
          return response.data.nombre;
        }

        // Último recurso
        return "Especialista ID: " + idEspecialista;
      } catch (error) {
        console.error("Error obteniendo nombre del especialista:", error);
        return "Especialista ID: " + idEspecialista;
      }
    },

    async obtenerAreas() {
      try {
        let url = `${env.endpoint}callcenter/areasConRequerimientos`;
        if (
          this.idEmpresaCaso &&
          (this.idEmpresaCaso === 1 || this.idEmpresaCaso === 2)
        ) {
          url += `?idEmpresa=${this.idEmpresaCaso}`;
        }

        const response = await axios.get(url);
        this.areas = response.data.map((area) => ({
          idArea: String(area.cc_id_area),
          area: area.cc_nombre_area,
        }));
      } catch (error) {
        console.error("Error cargando áreas:", error);
        this.areas = [];
      }
    },

    async llamarRequerimientos(idArea) {
      const index = this.areas.findIndex(
        (element) => element.idArea === idArea,
      );
      if (index !== -1) {
        this.editedItem.area = this.areas[index].area;
      }

      try {
        const idUsuario = localStorage.getItem("id");
        const idCaso = this.idCaso || null;
        let url = `${env.endpoint}callcenter/requerimientosarea?idArea=${idArea}&idUsuario=${idUsuario}`;
        if (idCaso) {
          url += `&idCaso=${idCaso}`;
        }
        const response = await axios.get(url);
        this.requerimientos = response.data;
      } catch (error) {
        console.error("Error cargando requerimientos por área:", error);
        this.requerimientos = [];
      }
    },

    verConversacion(item) {
      this.dialog2 = true;
      this.idCasoActual = item.cc_id_caso;
      const data = JSON.parse(JSON.stringify(item));
      this.chatItem = data.conversacion;
    },

    close2() {
      this.dialog2 = false;
      setTimeout(() => {
        this.editedItem = this.defaultItem;
        this.editedIndex = -1;
      }, 300);
    },

    close5() {
      this.dialog5 = false;
      this.editedItem.requerimientos = "";
      this.editedItem.idArea = "";
      this.editedItem.area = "";
      this.idEmpresaCaso = null;
      setTimeout(() => {
        this.editedItem = {
          Observaciones: "",
          requerimientos: "",
          idArea: "",
          area: "",
          estado: null,
          observacion: "",
        };
        this.editedIndex = -1;
      }, 300);
      this.obtenerCasos();
    },

    verObservacion(item) {
      this.dialog3 = true;
      this.observacion = item.observaciones;
    },

    close3() {
      this.dialog3 = false;
    },

    escalar(item) {
      this.dialog5 = true;
      this.fechaArea = item.fecha_area;
      this.idCaso = item.cc_id_caso;
      this.casoPendienteObj = item;
      this.idEmpresaCaso = item.idEmpresa ? parseInt(item.idEmpresa) : null;
      this.obtenerAreas();
    },

    async actualizarTiempoRestanteCaso(idCaso) {
      try {
        const resp = await axios.get(
          `${env.endpoint}callcenter/tiempoRestante?idCaso=${idCaso}`,
        );
        const caso = this.casos.find((c) => c.cc_id_caso == idCaso);
        if (caso) {
          caso.tiempoRestanteBackend = resp.data.tiempo_restante;
        }
      } catch (e) {
        console.error("Error actualizando tiempo:", e);
      }
    },

    verEvidencias(idCaso) {
      this.idCasoActual = idCaso;
      this.dialogEvidencias = true;
      this.cargandoEvidencias = false;
      this.evidencias = [];

      axios
        .get(`${env.endpointTraerEvidencias}?cc_id_caso=${idCaso}`)
        .then((response) => {
          this.evidencias = response.data.evidencias;
        })
        .catch((error) => {
          console.error("Error al cargar evidencias:", error);
          this.text = "Error al cargar las evidencias";
          this.snackbar = true;
        })
        .finally(() => {
          this.cargandoEvidencias = false;
        });
    },

    closeEvidencias() {
      this.dialogEvidencias = false;
      this.evidencias = [];
    },

    verImagenCompleta(url) {
      this.imagenSeleccionada = url;
      this.dialogImagenCompleta = true;
    },

    getFileName(url) {
      if (!url) return "Archivo";
      try {
        const fullPath = new URL(url).pathname;
        return fullPath.substring(fullPath.lastIndexOf("/") + 1);
      } catch (e) {
        const parts = url.split("/");
        return parts[parts.length - 1] || "Archivo";
      }
    },

    downloadFile(url) {
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", this.getFileName(url));
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    descargarImagen() {
      const link = document.createElement("a");
      link.href = this.imagenSeleccionada;
      link.download = this.imagenSeleccionada.split("/").pop();
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },

    formatDate(dateString) {
      const options = {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
      };
      return new Date(dateString).toLocaleDateString("es-ES", options);
    },

    verHistorial(item) {
      this.idCasoActual = item.cc_id_caso;
      this.dialogHistorial = true;
    },

    handleCasoVencido({ idCaso, mensaje }) {
      this.text = mensaje;
      this.snackbar = false;

      const caso = this.casos.find((c) => c.cc_id_caso == idCaso);
      if (caso) {
        caso.cerrados = 3;
        caso.estado_caso = 3;

        axios
          .get(`${env.endpoint}callcenter/tiempoRestante?idCaso=${idCaso}`)
          .then((resp) => {
            if (resp.data.tiempo_restante !== undefined) {
              caso.tiempoRestanteBackend = resp.data.tiempo_restante;
            }
          })
          .catch((error) => {
            console.error(
              `Error al obtener tiempo para caso suspendido vencido #${idCaso}:`,
              error,
            );
          });
      } else {
        this.obtenerCasos();
      }
    },

    async cargarDiasFestivos() {
      try {
        const anioActual = new Date().getFullYear();
        const anioSiguiente = anioActual + 1;
        const respuestaActual = await axios.get(
          `https://date.nager.at/api/v3/publicholidays/${anioActual}/CO`,
        );
        const respuestaSiguiente = await axios.get(
          `https://date.nager.at/api/v3/publicholidays/${anioSiguiente}/CO`,
        );
        this.diasFestivos = [
          ...respuestaActual.data,
          ...respuestaSiguiente.data,
        ].map((festivo) => ({
          fecha: new Date(festivo.date + "T00:00:00"),
          nombre: festivo.name,
        }));
      } catch (error) {
        this.diasFestivos = [];
      }
    },

    abrirConfirmacionAsignacionMasiva() {
      this.dialogConfirmarAsignacionMasiva = true;
    },

    async confirmarAsignacionMasiva() {
      this.dialogConfirmarAsignacionMasiva = false;
      try {
        const ids = this.casosSeleccionados.map((caso) => caso.cc_id_caso);

        const motivo =
          this.motivoReactivacion && this.motivoReactivacion.trim() !== ""
            ? this.motivoReactivacion
            : "Reactivación masiva";

        const fecha_reactivacion =
          this.fechaReactivacion && this.fechaReactivacion.trim() !== ""
            ? `${this.fechaReactivacion} 00:00:00`
            : new Date().toISOString().slice(0, 19).replace("T", " ");

        const payload = {
          ids,
          accion: "reactivar",
          data: { motivo, fecha_reactivacion },
        };

        const res = await axios.post(
          `${env.endpoint}callcenter/acciones_masivas`,
          payload,
        );
        if (res.data && res.data.resultados) {
          let mensaje = res.data.resultados
            .map((r) => `Caso #${r.idCaso}: ${r.mensaje}`)
            .join("<br>");
          this.text = mensaje;
          this.snackbar = true;

          res.data.resultados.forEach((r) => {
            if (r.estado) {
              axios.post(`${env.endpoint}historial/registrar_accion`, {
                cc_id_caso: r.idCaso,
                accion: 7,
                idUsuario: localStorage.getItem("id"),
                observaciones: motivo,
              });
            }
          });

          this.casosSeleccionados = [];
          this.obtenerCasos();
        }
        this.motivoReactivacion = "";
        this.fechaReactivacion = new Date().toISOString().slice(0, 10);
      } catch (error) {
        this.text = "Error al reactivar casos";
        this.snackbar = true;
      }
    },

    abrirAgregarObservacion(item) {
      this.casoSeleccionado = item;
      this.nuevaObservacion = "";
      this.dialogAgregarObservacion = true;
    },

    async guardarObservacion() {
      if (!this.nuevaObservacion.trim()) return;
      await axios.post(`${env.endpoint}historial/registrar_accion`, {
        cc_id_caso: this.casoSeleccionado.cc_id_caso,
        accion: 10,
        idUsuario: localStorage.getItem("id"),
        observaciones: this.nuevaObservacion,
      });
      this.dialogAgregarObservacion = false;
      this.text = "Observación guardada";
      this.snackbar = true;
    },

    verHistorialObservaciones(item) {
      this.idCasoActual = item.cc_id_caso;
      this.dialogHistorialObservaciones = true;
    },

    save5(idCaso) {
      const caso = JSON.stringify({
        requerimiento: this.casoPendienteObj.cc_nombre_requerimiento,
        area: this.casoPendienteObj.cc_nombre_area,
        fechaArea: this.fechaArea,
      });

      // ✅ Obtener el idUsuario del localStorage
      const idUsuario = localStorage.getItem('id');

      axios
        .get(
          `${env.endpoint}callcenter/escalarCaso?idRequerimiento=${this.editedItem.requerimientos}&info=${caso}&idCaso=${idCaso}&idUsuario=${idUsuario}` 
        )
        .then(() => {
          let nombreArea = "";
          const areaSeleccionada = this.areas.find(
            (a) => String(a.idArea) === String(this.editedItem.idArea),
          );
          if (areaSeleccionada && areaSeleccionada.area) {
            nombreArea = areaSeleccionada.area;
          } else if (this.editedItem.area) {
            nombreArea = this.editedItem.area;
          } else if (this.casoPendienteObj.cc_nombre_area) {
            nombreArea = this.casoPendienteObj.cc_nombre_area;
          } else {
            nombreArea = "No especificada";
          }

          let nombreRequerimiento = "";
          const reqSeleccionado = this.requerimientos.find(
            (r) =>
              String(r.cc_id_requerimientos) ===
              String(this.editedItem.requerimientos),
          );
          if (reqSeleccionado && reqSeleccionado.cc_nombre_requerimiento) {
            nombreRequerimiento = reqSeleccionado.cc_nombre_requerimiento;
          } else if (this.casoPendienteObj.cc_nombre_requerimiento) {
            nombreRequerimiento = this.casoPendienteObj.cc_nombre_requerimiento;
          } else {
            nombreRequerimiento = "No especificado";
          }

          const observaciones = `Escalado al área: ${nombreArea}, Requerimiento: ${nombreRequerimiento}`;
          axios
            .post(`${env.endpoint}historial/registrar_accion`, {
              cc_id_caso: idCaso,
              accion: 5,
              idUsuario: localStorage.getItem("id"),
              observaciones: observaciones,
            })
            .catch((error) => {
              console.error("Error al registrar la acción de escalado:", error);
            });
          swal({
            title: "Caso escalado",
            text: "El caso fue escalado exitosamente",
            icon: "success",
            timer: 4000,
          });
        });
      this.close5();
    },
  },
};
</script>
<style>
.dialogAsesor .div-icon {
  background: blue;
  height: 80px;
  width: 80px;
}
/* Inicio estilos para ingreso de imagens Jempoder*/
#drop-area {
  border: 2px dashed #ccc;
  padding: 20px;
  text-align: center;
  cursor: pointer;
}

#drop-area:hover {
  background-color: #f0f0f0;
}

#drop-area img {
  max-width: 100%;
  max-height: 200px;
  margin-bottom: 10px;
}

.upload-button {
  background-color: #4caf50;
  color: white;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  margin-top: 10px;
}

.upload-button:hover {
  background-color: #45a049;
}

.send-button {
  background-color: #008cba;
  color: white;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
  border: none;
  border-radius: 5px;
  margin-top: 10px;
}

.send-button:hover {
  background-color: #0074a8;
}

.send-button:disabled {
  background-color: #d3d3d3;
  cursor: not-allowed;
}
.reactivar-casos-btn {
  border-radius: 8px;
  letter-spacing: 1px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  margin-bottom: 8px;
}
.v-dialog__content,
.v-overlay__scrim,
.v-dialog,
.v-overlay {
  z-index: 3000 !important;
}

/* FIN estilos para ingreso de imagens Jempoder*/
.chat-message {
  word-break: break-word;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
  max-width: 100%;
}
@media (max-width: 599px) {
  .update-btn {
    min-width: auto !important;
    width: 40px !important;
    height: 40px !important;
    padding: 0 !important;
  }
}

/* Estilos para el filtro responsive */
.filter-container {
  margin-left: auto;
  margin-top: 26px;
}

.select-filter {
  max-width: 150px;
  min-width: 150px;
}

/* Responsive para dispositivos móviles */
@media (max-width: 768px) {
  .filter-container {
    margin-left: 16px;
    margin-top: 26px;
  }

  .select-filter {
    max-width: 14px;
    min-width: 14px;
  }
}

@media (max-width: 599px) {
  .filter-container {
    margin-left: 4px;
    margin-top: 0px;
  }

  .select-filter {
    max-width: 14px;
    min-width: 14px;
  }
}

/* Estilos para el botón de filtro en móvil */
.filter-icon-btn {
  color: #1d3c7f !important;
  align-self: center !important;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

.filter-icon-btn:hover {
  background-color: rgba(29, 60, 127, 0.1) !important;
}

/* Asegurar que el botón de filtro esté bien alineado */
@media (max-width: 599px) {
  .filter-icon-btn {
    height: 40px !important;
    width: 40px !important;
    align-self: center !important;
  }

  .filter-container {
    display: flex !important;
    align-items: center !important;
    height: 100% !important;
  }
}

/* Estilos responsive solo para pantallas pequeñas */
@media (max-width: 960px) {
  .v-toolbar .icon {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
  }

  .v-toolbar .icon .v-icon {
    transition: all 0.3s ease !important;
  }

  .v-toolbar .usuario {
    font-weight: bold !important;
    transition: all 0.3s ease !important;
    white-space: nowrap !important;
  }
}

/* Responsive para móvil */
@media (max-width: 599px) {
  .v-toolbar .icon {
    min-width: 40px !important;
    max-width: 40px !important;
    height: 40px !important;
  }

  .v-toolbar .icon .v-icon {
    font-size: 20px !important;
    margin-left: 8px !important;
    margin-top: 0 !important;
  }

  .v-toolbar .usuario {
    font-size: 14px !important;
    margin-left: 8px !important;
  }

  .v-toolbar .update-btn {
    margin-left: 8px !important;
    min-width: 40px !important;
    height: 40px !important;
    padding: 0 !important;
  }
}

/* Responsive para pantallas medianas (tablet) */
@media (min-width: 600px) and (max-width: 960px) {
  .v-toolbar .update-btn {
    margin-left: 8px !important;
    min-width: auto !important;
    padding: 0 12px !important;
    font-size: 12px !important;
  }

  .v-toolbar .update-btn .v-btn__content {
    padding: 0 8px !important;
  }
}

/* Responsive para tablet */
@media (min-width: 600px) and (max-width: 960px) {
  .v-toolbar .icon {
    min-width: 50px !important;
    max-width: 50px !important;
    height: 50px !important;
  }

  .v-toolbar .icon .v-icon {
    font-size: 24px !important;
    margin-left: 15px !important;
    margin-top: 12px !important;
  }

  .v-toolbar .usuario {
    font-size: 16px !important;
    margin-left: 12px !important;
  }
}

.offset-half {
  max-width: 98%;
  margin: 15px 1.2rem;
}

@media (max-width: 599px) {
  .offset-half {
    max-width: 98%;
    margin: 10px 6vw;
  }
}
</style>
